export default {"src":"/_next/static/media/evx.98ae0b1c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};